// http://playable.dev.com:8067/?doc=pt/playturbo%2fhandler%2fgmaker%2fproject.go
import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { cookRequestParams } from '@/common/request'

export function createGmakerProject(data) {
  return request({
    url: `${v2Host}/gmaker/project/create`,
    method: 'post',
    data,
  })
}

export function updateGmakerProject(data) {
  return request({
    url: `${v2Host}/gmaker/project/update`,
    method: 'post',
    data,
  })
}

export function mergeVideoResource(data) {
  return request({
    url: `${v2Host}/gmaker/project/merge-video`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
  })
}

export function relateProductGmakerProject(data) {
  return request({
    url: `${v2Host}/gmaker/project/relate-product`,
    method: 'post',
    data,
  })
}

export function getGmakerProjectInfo(params) {
  return request({
    url: `${v2Host}/gmaker/project/info`,
    method: 'get',
    params,
  })
}

export function getDmakerProjectOriginalInfo(params) {
  return request({
    url: `${v2Host}/gmaker/project/init-json`,
    method: 'get',
    params,
  })
}

export function previewGmakerProject(params, config) {
  return request({
    url: `${v2Host}/gmaker/project/preview`,
    method: 'get',
    params,
    ...config,
  })
}

export function saveGmakerProject(params, data, withoutError) {
  return request({
    url: `${v2Host}/gmaker/project/save`,
    method: 'post',
    data,
    params,
    withoutError: withoutError,
  })
}

export function deleteGmakerProject(data) {
  return request({
    url: `${v2Host}/gmaker/project/delete?id=${data.id}`,
    method: 'post',
    data: {},
  })
}

export function getGmakerProjectList(params) {
  return request({
    url: `${v2Host}/gmaker/project/list`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

/**
 * 重置作品
 * @param params {{id: number}}
 * @returns {AxiosPromise}
 */
export function resetGmakerProject(params) {
  return request({
    url: `${v2Host}/gmaker/project/reset`,
    method: 'post',
    params,
  })
}

export function packGmakerProject(data) {
  return request({
    url: `${v2Host}/gmaker/project/pack`,
    method: 'post',
    data,
  })
}

// params { id: number, basic_id: number}
export function getGmakerProjectChannels(params) {
  return request({
    url: `${v2Host}/gmaker/project/channels`,
    method: 'get',
    params,
  })
}

export function getGmakerDownloadStatus(params) {
  return request({
    url: `${v2Host}/gmaker/project/download-check`,
    method: 'get',
    params,
  })
}

export function getProjectDownloadCount(params) {
  return request({
    url: `${v2Host}/gmaker/project/download-count`,
    method: 'get',
    params,
  })
}

export function resetDemoProject(params) {
  return request({
    url: `${v2Host}/gmaker/project/reset-demo`,
    method: 'post',
    params,
    withoutError: true,
  })
}

export function getProjectDownloadResource(params) {
  return request({
    url: `${v2Host}/gmaker/project/download-resource`,
    method: 'get',
    params,
  })
}

// 普通制作pl下载接口
export function downloadCommonPlayable(params) {
  return request({
    url: `${v2Host}/gmaker/project/download`,
    method: 'get',
    params,
  })
}

export function getGmakerProjectHistoryName(params) {
  return request({
    url: `${v2Host}/gmaker/project/creatives`,
    method: 'get',
    params,
  })
}

export function getGmakerCopyLink(params) {
  return request({
    url: `${v2Host}/gmaker/project/copy-links`,
    method: 'get',
    params,
  })
}

// 下载模型蓝本骨骼
export function downloadModel(params) {
  return request({
    url: `${v2Host}/gmaker/project/download-model`,
    method: 'get',
    params,
  })
}
